import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { changeFilters } from 'actions/search';

import TypeFilters from './TypeFilters';

const mapDispatchToProps = { changeFilters };

export default withRouter(connect(null, mapDispatchToProps)(TypeFilters));



// WEBPACK FOOTER //
// ./src/components/TypeFilters/TypeFiltersContainer.js